import React from 'react';
import * as T from 'prop-types';

const style = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/icp-ajax-loader.gif)`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    height: '50px',
};

const style2 = {
    position: 'relative',
    top: '45%',
};

const style1 = {
    backgroundColor: '#00000087',
};

const LoadingPage = ({ message = 'Loading' }) => (
    <div className="fixed top-0 left-0 w-full h-screen z-10" style={style1}>
        <div
            className="text-white text font-semibold-xl text-center bg-transparent"
            style={style2}
        >
            {message}
            <div style={style} />
        </div>
    </div>
);

LoadingPage.propTypes = {
    message: T.string,
};

export default LoadingPage;
